import * as React from "react";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
// import IconButton from "@mui/material/IconButton";
import Collapse from "@mui/material/Collapse";
// import Button from "@mui/material/Button";
// import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";

type Props = {
  content: string;
};

export const AlertHeader = (props: Props) => {
  const { content } = props;
  const [open /*,setOpen */] = React.useState(true);

  const splitMessage = React.useCallback((str: string): string[] => {
    return str.split("\n");
  }, []);

  return (
    <Box sx={{ width: "100%" }}>
      <Collapse in={open}>
        <Alert
          icon={false}
          severity="error"
          // action={
          //   <IconButton
          //     aria-label="close"
          //     color="inherit"
          //     size="small"
          //     onClick={() => {
          //       setOpen(false);
          //     }}
          //   >
          //     <CloseIcon fontSize="inherit" />
          //   </IconButton>
          // }
          sx={{ mb: 2 }}
        >
          {splitMessage(content).map((line, index) =>
            line ? (
              <Typography sx={{ whiteSpace: "pre-wrap" }} key={index}>
                {line}
              </Typography>
            ) : (
              <br />
            )
          )}
        </Alert>
      </Collapse>
      {/* {!open && (
        <Button
          disabled={open}
          variant="outlined"
          onClick={() => {
            setOpen(true);
          }}
        >
          お知らせを開く
        </Button>
      )} */}
    </Box>
  );
};
